module.exports = __webpack_public_path__ + "img/headtop.a4fe7dee.jpg";